import React, { useEffect, useState } from "react";

const secondsToTime = (secs) => {
  const hours = Math.floor(secs / (60 * 60));
  const divisor_for_minutes = secs % (60 * 60);
  const minutes = Math.floor(divisor_for_minutes / 60);
  const divisor_for_seconds = divisor_for_minutes % 60;
  const seconds = Math.ceil(divisor_for_seconds);

  const obj = {
    "h": hours,
    "m": minutes,
    "s": seconds
  };
  return obj;
};

const CountdownTimer = ({
  totalTimeInSeconds,
  fromTimeInMilliseconds,
  buffer,
}) => {
  let timerInstance = null;
  const startAt = (buffer = 0) => {
    return totalTimeInSeconds - buffer;
  }

  const getStartAt = () => {
    if (fromTimeInMilliseconds) {
      const now = Date.now();
      const elapsedTime = Math.abs(fromTimeInMilliseconds - now);
      return startAt(buffer) - (elapsedTime / 1000);
    }
    return startAt(buffer);
  }

  const [time, updateTime] = useState(secondsToTime(getStartAt()));

  const [seconds, updateSeconds] = useState(getStartAt());

  useEffect(() => {
    if (seconds > 0) {
      timerInstance = setTimeout(countDown, 1000);
    }
    return () => {
      clearTimeout(timerInstance);
    }
  });

  const countDown = () => {
    // Remove one second, set state so a re-render happens.
    let nextTick = Math.ceil(seconds) - 1;
    updateTime(secondsToTime(nextTick));
    updateSeconds(nextTick);
  }

  const appendZero = (num) => {
    return num < 10 ? `0${num}` : `${num}`;
  }

  const { m, s } = time;
  return (
    <p className={`timeTag${seconds < 1 ? " expired" : ""}`}>
      <span className="railSeoSprite whiteClock appendRight8"></span>
      {
        seconds < 1
        ? <span className="transactionExpired">Transaction Expired</span>
        : `${appendZero(m)}m: ${appendZero(s)}s`
      }
    </p>
  )
}

export default CountdownTimer;
